export const GoogleMapTypes = {
  ROADMAP: 'roadmap',
  SATELLITE: 'satellite',
  HYBRID: 'hybrid',
  TERRAIN: 'terrain',
};

export const MapFilterTabs = {
  NEW: { label: 'New', path: 'new', apiEndpoint: 'new' },
  FAV: { label: 'Favs', path: 'likes', apiEndpoint: 'favs' },
  REJECT: { label: 'Reject', path: 'rejects', apiEndpoint: 'rejects' },
  OPEN: { label: 'Open Houses', path: 'open-houses', apiEndpoint: 'open-houses' },
};

export const DefaultMapZoom = 9;
